/**
 * Blend-name sanitizer.
 *
 * Used by the custom-blend builder so the user-supplied personal name renders
 * cleanly on the printed label (PNG fonts can't display emoji) and stays within
 * the 60-char database column. Mirrors `src/utils/blend_name.py` on the backend.
 *
 * Allowed: letters (incl. accented), digits, spaces, and the punctuation set
 * ' - . & , ! ?  Anything else is stripped silently as the user types.
 */
export const BLEND_NAME_MAX_LENGTH = 40;

// Whitelist regex; everything else is stripped. Uses Unicode letters so e.g.
// "Léa's Blend" passes through, but emoji and control characters do not.
const ALLOWED = /[\p{L}\p{N} '\-.,&!?]/gu;

/**
 * Clean a user-typed blend name for live input and for the cart payload.
 * Idempotent: sanitize(sanitize(x)) === sanitize(x).
 */
export function sanitizeBlendName(input) {
  if (input == null) return '';
  const matched = String(input).match(ALLOWED);
  if (!matched) return '';
  return matched
    .join('')
    .replace(/\s+/g, ' ')          // collapse runs of whitespace
    .slice(0, BLEND_NAME_MAX_LENGTH)
    .trim();
}
